import React from "react";
import { connect } from 'react-redux';
import ReactTable from 'react-table';
import ZSearch from '../../Common/ZSearch';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { cloneArray, isDefined, sortReactTable } from '../../../utils';
import { ZRole } from "../../../generated";

class QaQuestionResponseModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedOptions: [],
            flag: false,
            searchTeamQuery: undefined,
            terminateUser: false
        };
        this.wrapperRef = React.createRef();
        this.handleClickOutside = this.handleClickOutside.bind(this);

        this.selectOptions = this.selectOptions.bind(this);
        this.getOptionStyle = this.getOptionStyle.bind(this);

        this.onShowTerminate = this.onShowTerminate.bind(this);
        this.onHideTerminate = this.onHideTerminate.bind(this);

        this.onSearchTeam = this.onSearchTeam.bind(this);
    }

    componentDidMount() {
        document.addEventListener("mousedown", this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleClickOutside);
    }

    handleClickOutside(event) {
        const
            {
                onClose
            } = this.props;

        if (this.wrapperRef) {
            if (!this.wrapperRef.current.contains(event.target)) {
                onClose();
            }
        }
    }

    onShowTerminate() {
        this.setState({ terminateUser: true });
    }

    onHideTerminate() {
        this.setState({ terminateUser: false });
    }

    onSearchTeam({ target }) {
        this.setState({ searchTeamQuery: target.value });
    }

    selectOptions(selectedId, selectedName) {
        const
            {
                selectMultiple
            } = this.props;
        const selectedOption = { id: selectedId, value: selectedName }

        //deselecting
        if (this.state.selectedOptions.some(o => o.id === selectedId)) {
            this.state.selectedOptions = this.state.selectedOptions.filter(o => o.id !== selectedId);
        }
        else {
            if (selectMultiple) {
                this.state.selectedOptions.push(selectedOption);
            }
            else {
                this.state.selectedOptions[0] = selectedOption;
            }
        }
        this.setState({ flag: !this.state.flag });
    }

    getOptionStyle(optionId) {
        if (this.state.selectedOptions.some(o => o.id === optionId)) {
            const style =
            {
                border: '1px solid #C0EAED',
                boxShadow: '0px 1px 10px rgba(0, 0, 0, 0.15)',
                borderRadius: '8px'
            }
            return style;
        }
    }

    render() {
        const
            {
                options,
                qaSurveyFormQuestions,
                deleteAudit,
                comment,
                currentUser
            } = this.props;

        let result = {};
        result.columns = [
            {
                Header: 'Question',
                accessor: 'surveyQuestionIdNode'
            },
            {
                Header: 'Response',
                accessor: 'surveyQuestionPotentialResponseIdNode'
            },
        ];

        const loading = !(options && Array.isArray(options)) || !qaSurveyFormQuestions;
        if (loading === true) {
            return (<ReactTable className=""
                columns={result.columns}
                defaultPageSize={10}
                loading={loading}
                className="-striped -highlight"
            />);
        }

        result.data = cloneArray(options);

        if (isDefined(this.state.searchTeamQuery) && this.state.searchTeamQuery != '') {
            result.data = result.data.filter(a => a.name.toLowerCase().includes(this.state.searchTeamQuery.toLowerCase()));
        }

        if (result.data && Array.isArray(result.data)) {
            result.data.forEach(row => {
                const surveyFormQuestion = qaSurveyFormQuestions.find(sq => sq.id === row.surveyQuestionId);
                if (isDefined(surveyFormQuestion)) {

                    row.surveyQuestionIdNode = surveyFormQuestion && <div className="flex">{surveyFormQuestion.displayText}</div>;

                    if (isDefined(surveyFormQuestion.surveyQuestionPotentialResponses)) {
                        const response = surveyFormQuestion.surveyQuestionPotentialResponses
                            .find(sqpr => sqpr.id === row.surveyQuestionPotentialResponseId);
                        if (isDefined(response)) {
                            row.surveyQuestionPotentialResponseIdNode = <div>{response.value} ({response.pointValue})</div>
                        }
                    }
                }
            });
        }

        const teamsResultTable = (<ReactTable
            data={result.data}
            columns={result.columns}
            defaultPageSize={10}
            showPagination={true}
            loading={loading}
            className="-striped -highlight"
            getTrProps={(state, rowInfo) => {
                if (rowInfo && rowInfo.row) {
                    return {
                        onClick: () => this.selectOptions(rowInfo.original.id, rowInfo.original.name),
                        style: this.getOptionStyle(rowInfo.original.id)
                    };
                } else {
                    return {};
                }
            }}
            defaultSortMethod={sortReactTable}
        />);

        return <div ref={this.wrapperRef}>
            <label className="teams-table-for-manager all-teams-title">
                Comment: 
            </label>
            <div style={{ marginBottom: '15px' }}>{comment}</div>
            <div>
                {teamsResultTable}
            </div>
            {(currentUser.RoleId !== ZRole.Agent) &&
                <div className="flex justify-content-center">
                    {!this.state.terminateUser &&
                        <div className="v3-button agent-view-interactions"
                            style={{ background: '#E6F7F8', padding: '13px 17px' }} onClick={this.onShowTerminate}>Delete Audit</div>
                    }
                    {this.state.terminateUser &&
                        <div style={{ backgroundColor: '#cabfe2', padding: '20px', width: '20%', marginTop: '20px' }}>
                            <div>Are you sure you want to delete this audit? </div>
                            <div className="flex justify-content-space-evenly">
                                <div className="v3-button agent-view-interactions"
                                    style={{ background: '#E6F7F8', padding: '13px 17px' }} onClick={this.onHideTerminate}>No</div>
                                <div className="v3-button agent-view-interactions"
                                    style={{ background: '#E6F7F8', padding: '13px 17px' }} onClick={() => deleteAudit()}>Yes</div>
                            </div>
                        </div>
                    }
                </div>}
        </div>;
    };
}

const select = state => ({ ...state.session });
export default connect(select)(QaQuestionResponseModal);

